(function () {
  var KEY = 'torque_garage';
  function get() { try { return JSON.parse(localStorage.getItem(KEY)); } catch (e) { return null; } }
  function set(v) { try { v ? localStorage.setItem(KEY, JSON.stringify(v)) : localStorage.removeItem(KEY); } catch (e) {} }
  function label(g) { return g.year + ' ' + g.make + ' ' + g.model; }
  var g = get();

  var chip = document.querySelector('[data-garage-chip]');
  if (chip && g) chip.textContent = label(g);

  var f = document.querySelector('[data-finder]');
  if (f) {
    var map = {};
    f.dataset.vehicles.split(/\r?\n/).forEach(function (l) {
      var p = l.split(':'); if (p.length < 2) return;
      map[p[0].trim()] = p[1].split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    });
    var y = f.querySelector('[data-year]'), mk = f.querySelector('[data-make]'), md = f.querySelector('[data-model]');
    var opts = function (el, list, ph) {
      el.innerHTML = '<option value="">' + ph + '</option>' + list.map(function (v) { return '<option>' + v + '</option>'; }).join('');
    };
    var years = []; for (var i = +f.dataset.end; i >= +f.dataset.start; i--) years.push(i);
    opts(y, years, 'Year'); opts(mk, Object.keys(map), 'Make'); opts(md, [], 'Model');
    mk.addEventListener('change', function () { opts(md, map[mk.value] || [], 'Model'); });
    if (g) { y.value = g.year; mk.value = g.make; mk.dispatchEvent(new Event('change')); md.value = g.model; }
    f.addEventListener('submit', function () {
      set({ year: y.value, make: mk.value, model: md.value });
      f.elements.q.value = mk.value + ' ' + md.value;
    });
    var clear = document.querySelector('[data-garage-clear]');
    if (clear && g) {
      clear.hidden = false;
      clear.addEventListener('click', function (e) { e.preventDefault(); set(null); location.reload(); });
    }
  }

  var fit = document.querySelector('[data-fit]');
  if (fit && !fit.hidden) {
    var list = fit.dataset.fits.split('|').filter(Boolean), msg = fit.querySelector('[data-fit-msg]');
    if (g) {
      var key = (g.make + ' ' + g.model).toLowerCase();
      var ok = list.some(function (s) {
        if (s.indexOf(key) < 0) return false;
        var r = s.match(/(\d{4})\s*-\s*(\d{4})/), one = s.match(/\b(\d{4})\b/), yr = +g.year;
        if (r) return yr >= +r[1] && yr <= +r[2];
        if (one) return yr === +one[1];
        return true;
      });
      fit.classList.add(ok ? 'is-fit' : 'is-nofit');
      msg.textContent = ok ? 'Fits your ' + label(g) + '.' : 'Not listed for your ' + label(g) + '. Contact us before ordering.';
    }
  }

  document.querySelectorAll('[data-autosubmit]').forEach(function (form) {
    form.addEventListener('change', function () { form.submit(); });
  });
  var main = document.getElementById('MainImg');
  document.querySelectorAll('[data-thumb]').forEach(function (b) {
    b.addEventListener('click', function () {
      if (!main) return; main.removeAttribute('srcset'); main.src = b.dataset.thumb;
    });
  });
})();
(function () {
  var lk = document.querySelector('[data-lookup]'); if (!lk) return;
  var rows = lk.dataset.rows.split(/\r?\n/).map(function (l) {
    var p = l.split('|').map(function (s) { return s.trim(); }); if (p.length < 7) return null;
    return { make: p[0], model: p[1], engine: p[2], sb: +p[3], sn: +p[4], tb: +p[5], tn: +p[6],
      opts: (p[7] || '').split(';').map(function (o) { var i = o.indexOf('='); return i < 0 ? { n: o.trim() } : { n: o.slice(0, i).trim(), u: o.slice(i + 1).trim() }; }).filter(function (o) { return o.n; }) };
  }).filter(Boolean);
  var q = lk.querySelector('[data-lk-q]'), mk = lk.querySelector('[data-lk-make]'), md = lk.querySelector('[data-lk-model]'),
      en = lk.querySelector('[data-lk-engine]'), out = lk.querySelector('[data-lk-result]'), ms = lk.querySelector('[data-lk-matches]');
  function esc(s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML.replace(/"/g, '&quot;'); }
  function uniq(a) { return a.filter(function (v, i) { return a.indexOf(v) === i; }); }
  function by(f) { return rows.filter(f); }
  function fill(el, list, ph) { el.innerHTML = '<option value="">' + ph + '</option>' + list.map(function (v) { return '<option>' + esc(v) + '</option>'; }).join(''); }
  function bar(label, unit, s, t) {
    var g = t - s, p = s ? Math.round(g / s * 100) : 0;
    return '<div class="lk-row"><header><span>' + label + '</span><span>' + s + ' to ' + t + ' ' + unit + ' (+' + g + ' ' + unit + ', +' + p + '%)</span></header>' +
      '<div class="lk-track"><i class="t" style="width:100%"></i><i class="s" style="width:' + (t ? Math.round(s / t * 100) : 0) + '%"></i></div></div>';
  }
  function show(r) {
    out.innerHTML = '<div class="lk-card"><h3>' + esc(r.make + ' ' + r.model + ' ' + r.engine) + '</h3>' +
      bar('Power', 'bhp', r.sb, r.tb) + bar('Torque', 'Nm', r.sn, r.tn) +
      '<p class="pn">Dark bar is stock output. Red is the gain.</p>' +
      (r.opts.length ? '<h4>Options available</h4><ul class="lk-opts">' + r.opts.map(function (o) {
        return '<li>' + (o.u ? '<a class="btn alt" href="' + esc(o.u) + '">' + esc(o.n) + '</a>' : esc(o.n)) + '</li>';
      }).join('') + '</ul>' : '') + '<p><a class="btn" href="#quote">Get a quote for this vehicle</a></p></div>';
    var qv = document.querySelector('[data-quote-vehicle]'); if (qv) qv.value = r.make + ' ' + r.model + ' ' + r.engine;
  }
  fill(mk, uniq(rows.map(function (r) { return r.make; })), 'Make'); fill(md, [], 'Model'); fill(en, [], 'Engine');
  mk.addEventListener('change', function () { fill(md, uniq(by(function (r) { return r.make === mk.value; }).map(function (r) { return r.model; })), 'Model'); fill(en, [], 'Engine'); out.innerHTML = ''; });
  md.addEventListener('change', function () { fill(en, uniq(by(function (r) { return r.make === mk.value && r.model === md.value; }).map(function (r) { return r.engine; })), 'Engine'); out.innerHTML = ''; });
  en.addEventListener('change', function () {
    var r = by(function (r) { return r.make === mk.value && r.model === md.value && r.engine === en.value; })[0]; if (r) show(r);
  });
  q.addEventListener('input', function () {
    var w = q.value.toLowerCase().split(/\s+/).filter(Boolean); ms.innerHTML = ''; if (!w.length) return;
    by(function (r) { var t = (r.make + ' ' + r.model + ' ' + r.engine).toLowerCase(); return w.every(function (x) { return t.indexOf(x) > -1; }); })
      .slice(0, 8).forEach(function (r) {
        var li = document.createElement('li'), b = document.createElement('button'); b.type = 'button'; b.textContent = r.make + ' ' + r.model + ' ' + r.engine;
        b.addEventListener('click', function () {
          mk.value = r.make; mk.dispatchEvent(new Event('change')); md.value = r.model; md.dispatchEvent(new Event('change')); en.value = r.engine; show(r);
        });
        li.appendChild(b); ms.appendChild(li);
      });
    if (!ms.children.length) ms.innerHTML = '<li>No match. Contact us and we\'ll check your vehicle.</li>';
  });
})();
